module.exports = __webpack_public_path__ + "static/img/cqcBanner.706d4a71.png";